import { z } from 'zod';

import {
  MILEAGE_UNIT_VALUES,
  mileageUnitSchema,
  minMaxSchema,
  vehicleDetailsSchema,
} from './SharedSchema';
import { generateMock } from '../../../../../../../utils/generate-mock';

const REQUIRED_ERROR_MESSAGE = 'This field is required';

const mileageUnitFormSchema = z.enum(MILEAGE_UNIT_VALUES, {
  message: REQUIRED_ERROR_MESSAGE,
});

const privateValuationResponseSchema = z.object({
  valuation: z.number(),
  expectedDealerOfferRange: minMaxSchema,
  privateMarketOfferRange: minMaxSchema,
  vehicleDetails: vehicleDetailsSchema,
});

const privateValuationSubmissionSchema = z.object({
  registrationNumber: z
    .string()
    .min(1, { message: 'Registration number cannot be empty' }),
  mileageUnit: mileageUnitFormSchema,
  mileage: z.string().min(1, { message: 'Mileage cannot be empty' }),
});

const mockPrivateValuationData = generateMock(privateValuationResponseSchema, {
  valuation: 5256,
  expectedDealerOfferRange: {
    min: 3942,
    max: 4468,
  },
  privateMarketOfferRange: {
    min: 4994,
    max: 5256,
  },
  vehicleDetails: {
    bodyType: 'Saloon',
    colour: 'Black',
    engineCapacityInCc: 1896,
    fuelType: 'Diesel',
    make: 'Volkswagen',
    model: 'Passat',
    noOfOwners: 4,
    registrationNumber: '10D324',
    transmission: 'Manual',
    yearOfManufacture: '2010',
    mileage: 1000,
    mileageUnit: mileageUnitSchema.enum.Kilometres,
  },
});

export {
  privateValuationResponseSchema,
  privateValuationSubmissionSchema,
  mileageUnitSchema,
  mockPrivateValuationData,
};

export type VehicleDetails = z.infer<typeof vehicleDetailsSchema>;
export type PrivateValuation = z.infer<typeof privateValuationResponseSchema>;
export type PrivateValuationFormInputs = z.infer<
  typeof privateValuationSubmissionSchema
>;
